export const SHOW_ALERT = 'SHOW_ALERT'
export const HIDE_ALERT = 'HIDE_ALERT'



// WEBPACK FOOTER //
// ./src/store/actions/alert.js